import { DigitalIdApi } from './DigitalIdApi'

export const apiReducers = {
  [DigitalIdApi.reducerPath]: DigitalIdApi.reducer
}

export const apiMiddleware = [DigitalIdApi.middleware]
